import * as St from './FdDesignSetting.styled';
import { useUserPageContextValueHook } from '@/contexts/UserPageContextProvider';
import { SgBackgroundDesign } from './segments/SgBackgroundDesign/SgBackgroundDesign';
import { SgFontDesign } from './segments/SgFontDesign/SgFontDesign';
import { SgNoticeDesign } from './segments/SgNoticeDesign/SgNoticeDesign';
import { SgProfileDesign } from './segments/SgProfileDesign/SgProfileDesign';
import { SgSocialDesign } from './segments/SgSocialDesign/SgSocialDesign';

export function FdDesignSetting({
    onRefreshPreviewViewer
}) {
    const userPage = useUserPageContextValueHook()?.userPage;

    // 각 항목이 저장값으로 처음 상태를 잡으므로 페이지 정보가 컨텍스트에 들어온 뒤에 그린다
    if (!userPage?.id) {
        return null;
    }

    return (
        <>
            <St.Container>
                <St.FragmentListWrapper>
                    <St.DropdownFieldWrapper>
                        <SgProfileDesign
                            onRefreshPreviewViewer={onRefreshPreviewViewer}
                        />
                    </St.DropdownFieldWrapper>
                    <St.DropdownFieldWrapper>
                        <SgBackgroundDesign
                            onRefreshPreviewViewer={onRefreshPreviewViewer}
                        />
                    </St.DropdownFieldWrapper>
                    <St.DropdownFieldWrapper>
                        <SgFontDesign
                            onRefreshPreviewViewer={onRefreshPreviewViewer}
                        />
                    </St.DropdownFieldWrapper>
                    <St.DropdownFieldWrapper>
                        <SgNoticeDesign
                            onRefreshPreviewViewer={onRefreshPreviewViewer}
                        />
                    </St.DropdownFieldWrapper>
                    <St.DropdownFieldWrapper>
                        <SgSocialDesign
                            onRefreshPreviewViewer={onRefreshPreviewViewer}
                        />
                    </St.DropdownFieldWrapper>
                </St.FragmentListWrapper>
            </St.Container>
        </>
    );
}